import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthRoutingModule } from './auth-routing.module';
import { SharedModule } from '../shared/shared.module';
import { UsernameLostComponent } from './username-lost/username-lost.component';
import { PasswordLostComponent } from './password-lost/password-lost.component';
import { AuthComponent } from './auth.component';
import { RouterModule } from '@angular/router';
import { CodeLostComponent } from './code-lost/code-lost.component';
import { LockIdentityComponent } from './lock-identity/lock-identity.component';
import { PasswordResetComponent } from './password-reset/password-reset.component';
import { PasswordModifyComponent } from './password-modify/password-modify.component';
import { EmailVerifyComponent } from './email-verify/email-verify.component';
import {LoginModule} from './login/login.module';



@NgModule({
  declarations: [
    UsernameLostComponent,
    PasswordLostComponent,
    AuthComponent,
    CodeLostComponent,
    LockIdentityComponent,
    PasswordResetComponent,
    PasswordModifyComponent,
    EmailVerifyComponent,
  ],
  imports: [
    CommonModule,
    AuthRoutingModule,
    SharedModule,
    RouterModule,
    LoginModule,
  ]
})
export class AuthModule { }
